window.addEventListener('load', function () {
  $('.js-xbc-show-dialog').click(function () {
    var mask = $(this).attr('data-mask')
    var body_mask = $('body > .' + mask)
    if (body_mask.length === 0) {
      $('body').append($(this).parent().find('.xbc-mask').clone())
      body_mask = $('body > .' + mask)
      bindCloseEvent(body_mask.find('.xbc-close'))
    }
    body_mask.fadeIn(200)
    $('body').addClass('disabled-scroll')
  })
  function bindCloseEvent (close) {
    close.click(function (e) {
      $(this).parent().parent().hide()
      $('body').removeClass('disabled-scroll')
    })
  }
})
